// 如果是 uc 登录回调
if (location.search) {
    const search = new URLSearchParams(location.search);

    const _a = JSON.parse(search.get('_a'));
    if (_a && _a.hasOwnProperty('token') && _a.hasOwnProperty('user_id')) {
        localStorage.setItem('token', _a.token);
        localStorage.setItem('user_id', _a.user_id);

        const url = new URL(location.href);
        url.searchParams.delete('_a');
        location.href = url.href;
    }
}

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store.js';
import '@/assets/css/normalize.css';
import '@/assets/font/font.css';
import '@/assets/css/common.css';
import '@/assets/css/rewriteEl.scss';
import '@/assets/css/drawer.css';
import '@/assets/css/searchCont.css';
import '@/assets/css/mediaQuery.scss';
import '@/assets/css/dialogCommon.scss';

import DonMessage from './comon/plugins/element';
Vue.prototype.$message = new DonMessage();

import tinymce from 'tinymce';
import VueTinymce from '@packy-tang/vue-tinymce';

Vue.prototype.$tinymce = tinymce; // 将全局tinymce对象指向给Vue作用域下
Vue.use(VueTinymce);              // 安装vue的tinymce组件

import Moment from 'moment';
Vue.prototype.moment = Moment;
import VueBus from 'vue-bus'; //中央事件总线
Vue.use(VueBus);
import ECharts from 'vue-echarts/components/ECharts.vue';
Vue.component('v-chart', ECharts);
import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

// oss 图片通过这个函数统一处理，主要是为了让兼容 webp 的浏览器自动加载 webp 格式，不兼容的浏览器保留 jpg
// 检测WebP支持
window.webp = false;

function detectWebP(callback) {
    const webP = new Image();
    webP.onload = webP.onerror = function () {
        callback(webP.height == 2);
    };
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
};
detectWebP(supported => window.webp = supported);
Vue.prototype.ossImg = (urls, width, height, updatedTime) => {
    const ossWords = '';
    let ossParams = [],
        queryParams = [];
    Object.entries({
        w_: width,
        h_: height
    }).forEach(item => {
        const [key, val] = item;
        let newVal;
        if (val && (newVal = parseInt(val)) > 0) {
            ossParams.push(`${key}${newVal}`);
        }
    });
    // resize
    ossParams.length > 0 && ossParams.unshift('image/resize,m_fill')
    // webp
    window.webp && ossParams.unshift('image/format,webp');
    // oss params
    ossParams.length > 0 && queryParams.push(`x-oss-process=${ossParams.join(',')}`);
    // updatedTime
    updatedTime && queryParams.push(`t=${updatedTime.replace(/[^0-9]+/g,'')}`);
    // query
    const query = queryParams.length > 0 && `?${queryParams.join('&')}` || '';
    if (urls instanceof Array) {
        return urls.map(url => url + ((!ossWords || url.indexOf(ossWords) > 0) && query || '').replace(',image/', '/'));
    }
    return urls + ((!ossWords || urls.indexOf(ossWords) > 0) && query || '').replace(',image/', '/');
};

/**
 * 全局filter
 */
import * as filters from '../src/comon/filter/ellipsis';
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

/**
 * 1、 < 60 s, 显示为“ 刚刚”
 * 2、 >= 1 min && < 60 min, 显示与当前时间差“ XX分钟前”
 * 3、 >= 60 min && < 1 day, 显示与当前时间差“ 今天 XX: XX”
 * 4、 >= 1 day && < 1 year, 显示日期“ XX月XX日 XX: XX”
 * 5、 >= 1 year, 显示具体日期“ XXXX年XX月XX日 XX: XX”
 */
function timeFormat(time) {
    const date = new Date(time),
        curDate = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 10,
        day = date.getDate(),
        hour = date.getHours(),
        minute = date.getMinutes(),
        curYear = curDate.getFullYear(),
        curHour = curDate.getHours();
        let timeStr;

    if (year < curYear) {
        timeStr = year + '年' + month + '月' + day + '日 ' + hour + ':' + minute;
    } else {
        const pastTime = curDate - date,
            pastH = pastTime / 3600000;

        if (pastH > curHour) {
            timeStr = month + '月' + day + '日 ' + hour + ':' + minute;
        } else if (pastH >= 1) {
            timeStr = '今天 ' + hour + ':' + minute + '分';
        } else {
            const pastM = curDate.getMinutes() - minute;
            if (pastM > 1) {
                timeStr = pastM + '分钟前';
            } else {
                timeStr = '刚刚';
            }
        }
    }

    return timeStr;
}

Vue.filter('timeFormat', timeFormat);

// 若是没有开启Devtools工具，在开发环境中开启，在生产环境中关闭
/* if (process.env.NODE_ENV == 'development') {
    Vue.config.devtools = true;
} else {
    Vue.config.devtools = false;
} */
Vue.config.productionTip = false;
const that = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

export default that;
